const LOGOUT_TIMEOUT_MS = 3000;

let ending: Promise<void> | undefined;
let ended = false;

// A page restored from the back/forward cache keeps this module's state, so let
// it end its own session again on a later 401. A logout still in flight stays
// deduplicated.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    ended = false;
  }
});

const goToLogin = () => window.location.assign('/login');

async function logoutAndNavigate(navigate: () => void): Promise<void> {
  localStorage.removeItem('atlasToken');

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), LOGOUT_TIMEOUT_MS);
  try {
    await fetch('/api/logout', {
      method: 'POST',
      credentials: 'include',
      signal: controller.signal,
    });
  } catch (e) {
    console.error(e);
  } finally {
    clearTimeout(timeout);
  }

  ending = undefined;
  ended = true;
  navigate();
}

// Ends an expired session exactly once per page load: concurrent 401 responses
// must not race each other with navigations that cancel the logout request.
export function endSession(navigate: () => void = goToLogin): Promise<void> {
  if (ended) {
    return Promise.resolve();
  }
  if (!ending) {
    ending = logoutAndNavigate(navigate);
  }
  return ending;
}
